import { ProgressSpinner } from 'primereact/progressspinner';

const Loading = ({style={}}) => (
  <div className="global-loading" style={{ display: 'flex', justifyContent: 'center',height: '90vh', alignItems: 'center',...style }}>
    <ProgressSpinner />
  </div>
);

export default Loading;